'use client';

import React, { forwardRef, useImperativeHandle } from "react";

const PrintComponent = forwardRef(({ title = "Print", data = [], columns = [] }, ref) => {

  const generateFileName = () => {
    const now = new Date();
    const yyyy = now.getFullYear();
    const mm = String(now.getMonth() + 1).padStart(2, "0");
    const dd = String(now.getDate()).padStart(2, "0");
    const hh = String(now.getHours()).padStart(2, "0");
    const min = String(now.getMinutes()).padStart(2, "0");
    return `${title.replace(/\s+/g, "_")}_${yyyy}-${mm}-${dd}_${hh}-${min}`;
  };

  const handlePrint = () => {
    const fileName = generateFileName();
    const currentUrl =
      (window.opener && window.opener.location.href) ||
      window.location.href ||
      "";

    const tableHTML = `
      <table>
        <thead>
          <tr>
            ${columns.map(col => `<th>${col.header}</th>`).join("")}
          </tr>
        </thead>
        <tbody>
          ${data.map(row => `
            <tr>
              ${columns.map(col => {
                const value = col.render ? col.render(row[col.field]) : row[col.field] ?? "-";
                return `<td>${value}</td>`;
              }).join("")}
            </tr>
          `).join("")}
        </tbody>
      </table>
    `;

    const newWin = window.open("", fileName, "width=900,height=700");
    if (!newWin) return;

    newWin.document.write(`
      <html>
        <head>
          <title>${fileName}</title>
          <style>
            @page { size: A4; margin: 15mm; }

            body {
              font-family: "Segoe UI", Arial, sans-serif;
              font-size: 12px; /* slightly smaller font */
              color: #000 !important;
              background: #fff !important;
              margin: 0;
              padding: 0;
              line-height: 1.3;
            }

            * {
              color: #000 !important;
              background: #fff !important;
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
            }

            .title {
              text-align: center;
              font-size: 18px;
              font-weight: 600;
              margin-bottom: 10px;
              padding-bottom: 8px;
              border-bottom: 1px solid #000;
            }

            table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 5px;
              table-layout: fixed; /* maximize space usage */
            }

            th {
              border-bottom: 1px solid #000;
              padding: 6px 4px;
              text-align: left;
              font-weight: 600;
              font-size: 12px;
            }

            td {
              border-bottom: 1px solid #000;
              padding: 4px 3px;
              font-size: 12px;
              word-wrap: break-word;
            }

            table, tr, td, th {
              page-break-inside: avoid !important;
            }

            @media print {
              .footer {
                position: fixed;
                bottom: 10mm;
                left: 0;
                right: 0;
                text-align: center;
                font-size: 11px;
                color: #000;
              }
            }
          </style>
        </head>
        <body>
          <div class="title">${title}</div>
          ${tableHTML}
          <div class="footer">Printed from: ${currentUrl}</div>
        </body>
      </html>
    `);

    newWin.document.close();
    setTimeout(() => { newWin.focus(); newWin.print(); newWin.close(); }, 300);
  };

  useImperativeHandle(ref, () => ({ handlePrint }));

  return null; // no visible DOM needed
});

export default PrintComponent;